module.exports = __webpack_public_path__ + "static/media/legal.9e2efcdd.png";